import { SpeechRecognitionLanguageEnglish } from "@/util/constants";
import {
	AudioConfig,
	OutputFormat,
	ServicePropertyChannel,
	SpeechConfig,
	SpeechRecognizer
} from "microsoft-cognitiveservices-speech-sdk";
import { IAzureSpeechRecognizerCognitiveService } from ".";

class AzureSpeechRecognizerCognitiveServiceClass implements IAzureSpeechRecognizerCognitiveService {
	speechConfig: SpeechConfig;

	constructor(speechKey: string, speechRegion: string) {
		this.speechConfig = SpeechConfig.fromSubscription(speechKey, speechRegion);
		this.speechConfig.speechRecognitionLanguage = SpeechRecognitionLanguageEnglish;
		this.speechConfig.outputFormat = OutputFormat.Detailed;
		this.speechConfig.enableDictation();
		this.speechConfig.setServiceProperty("punctuation", "explicit", ServicePropertyChannel.UriQueryParameter); // done to remove punctuation
	}

	getSpeechRecognizer(audioConfig: AudioConfig): SpeechRecognizer {
		return new SpeechRecognizer(this.speechConfig, audioConfig);
	}
}

export const AzureSpeechRecognizerCognitiveService = AzureSpeechRecognizerCognitiveServiceClass;
